/**
 * JWT utilities — decode only, no verification.
 */
import Cookies from "js-cookie";

/**
 * Decode a JWT payload without verification.
 * @param {string} token
 * @returns {object|null}
 */
export function decodeJwtPayload(token) {
    try {
        if (!token || typeof token !== "string") return null;
        const parts = token.split(".");
        if (parts.length !== 3) return null;

        let payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
        const pad = payload.length % 4;
        if (pad) payload += "=".repeat(4 - pad);

        return JSON.parse(atob(payload));
    } catch {
        return null;
    }
}

/**
 * Get the active profile ID from the current JWT access token.
 * @returns {string|null}
 */
export function getActiveProfileId() {
    if (typeof window === "undefined") return null;
    try {
        const token = Cookies.get("userAccessToken");
        if (!token) return null;
        const payload = decodeJwtPayload(token);
        return payload?.profileId || payload?.profile_id || payload?.pid || null;
    } catch {
        return null;
    }
}
